import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  static appConfig: IAppConfig;

  constructor(private http: HttpClient) {}

  load() {
    const jsonFile = `../assets/Config/Config.json`;

    return new Promise<void>((resolve, reject) => {
      this.http
        .get(jsonFile)
        .toPromise()
        .then((response: IAppConfig) => {
          AppConfigService.appConfig = <IAppConfig>response;
          resolve();
        })
        .catch((response: any) => {
          reject(`Failed to load the config file`);
        });
    });
  }
}
export interface IAppConfig {
  redirectUri: string;
}
